const points = [
  {
    icon: '💻',
    title: 'On your machine, not a vendor’s',
    description:
      'Capture runs locally—no bot dials in, and Solidly never sees your call. Transcription goes to your own provider, on your own key.',
  },
  {
    icon: '⚡',
    title: 'Work with them live',
    description:
      'Tap a coworker mid-meeting and it answers from what’s actually been said—your team is in the room with you, not emailing a summary an hour later.',
  },
  {
    icon: '🤝',
    title: 'Handed off when you wrap',
    description:
      'Every line is attributed by voiceprint, so when the meeting ends the action items route straight to the right coworker.',
  },
];

const Meetings = () => {
  return (
    <section className="meetings" id="meetings">
      <div className="section-container">
        <p className="overline overline--center">AI AGENTS IN YOUR MEETING</p>
        <h2 className="section-title">Your team sits in. No bot ever joins.</h2>
        <p className="section-subtitle">
          Other meeting assistants dial a bot into your call and record to the cloud. SolidlyAI
          captures audio on your own machine—nothing joins the call, nothing ships to a vendor.
          Your coworkers just listen in.
        </p>

        <div className="meetings-callout">
          <span className="meetings-callout-bad">🤖 “A notetaker bot has joined the call.”</span>
          <span className="meetings-callout-arrow" aria-hidden="true">→</span>
          <span className="meetings-callout-good">Nothing joins. Your team just listens in.</span>
        </div>

        <div className="meetings-grid">
          {points.map((p, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>

        <div className="meetings-note mono">
          Best-in-class transcription on your own key—no intermediary reselling your meeting back
          to you.
        </div>
      </div>
    </section>
  );
};

export default Meetings;
